import request from '@/utils/request'
// 首页获取id
export function lableHome(languageId) {
    return request({
        url: `/home/label/?languageId=${languageId}`,
        method: 'get'
    })
}
// 获取首页企业8
export function getQiye(labelId,languageId){
    return request({
        url:'/home/article',
        methods: 'get',
        params :{ labelId,languageId }
    })
}
// 获取首页资源服务6
export function getZiyuan(labelId,languageId){
    return request({
        url:'/home/resources',
        methods: 'get',
        params :{ labelId,languageId }
    })
}
// 获取首页新闻媒体视频1条数据
export function getVideo(labelId,languageId){
    return request({
        url:'/home/media',
        methods: 'get',
        params :{ labelId,languageId }
    })
}
// 获取首页新闻媒体热点新闻
export function hotnews(labelId,languageId){
    return request({
        url:'/home/hotnews',
        methods: 'get',
        params :{ labelId,languageId }
    })
}
  
  
  


// WEBPACK FOOTER //
// ./src/api/home.js